<template>
    <div>
        <b-row>
            <b-col md="6">
                <b-card>
                    <h4 class="strong">General Information</h4>
                    <hr />
                    <b-row>
                        <b-col md="6">
                            <b-form-text>Well Name</b-form-text>
                            {{ general.name }}
                        </b-col>
                        <b-col md="6">
                            <b-form-text>Field Name</b-form-text>
                            {{ general.field }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Created by</b-form-text>
                            {{ general.creator }}
                        </b-col>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Company</b-form-text>
                            {{ general.company }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Engineer</b-form-text>
                            {{ general.engineer }}
                        </b-col>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Date</b-form-text>
                            {{ general.date }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Instrument</b-form-text>
                            {{ general.instrument }}
                        </b-col>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Calculation Method</b-form-text>
                            {{ general.method }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Well Type</b-form-text>
                            {{ general.type }}
                        </b-col>
                        <b-col md="6" class="mt-3">
                            <b-form-text>Unit Measurement</b-form-text>
                            {{ general.unit == "m" ? "Meter (m)" : "Feet (ft)" }}
                        </b-col>
                    </b-row>
                    <b-form-text class="mt-3">Comment / Description</b-form-text>
                    {{ general.comment == "" ? "-" : general.comment }}
                    <div class="mt-4" style="text-align: right">
                        <b-btn variant="danger" v-b-modal.modal_delete>
                            Delete This Calculation
                        </b-btn>
                    </div>
                </b-card>
                <b-modal id="modal_delete" 
                ok-variant="danger" @ok="didTapDelete"
                title="Deletion"
                :ok-title="isDeleting ? 'Deleting...' : 'Delete'" :ok-disabled="isDeleting"
                :no-close-on-backdrop="isDeleting" :no-close-on-esc="isDeleting"
                :cancel-disabled="isDeleting">
                    <b-form-text>Please re-enter your password again below:</b-form-text>
                    <b-input type="password" v-model="password" />
                    <b-alert class="mt-4" variant="warning" show>
                        <strong>Warning!</strong>
                        <b-form-text style="color: black !important">
                            Deleted calculations cannot be recovered.
                        </b-form-text>
                    </b-alert>
                </b-modal>
            </b-col>
            <b-col md="6">
                <b-card>
                    <h4 class="strong">Summary</h4>
                    <hr />
                    <b-form-text v-if="!isSummaryAvailable">
                        You are not allowed to download the summary because your calculation is incomplete. Please recheck that all inputs have been filled.<br /><br />
                        Required tabs to be filled and saved: <strong>Data Input, Pump Selection, and Equipment Selection</strong>
                    </b-form-text>
                    <div v-else>
                        <b-form-text>
                            Download an Excel file summarizing this calculation. Make sure that you have saved any changes in <strong>Data Input, Pump Selection, and Equipment Selection</strong>
                            to reflect the changes in the summary.
                        </b-form-text>
                        <b-alert class="mt-4" variant="info" show>
                            <strong>Attaching IPR and Pump Curves Charts</strong>
                            <b-form-text style="color: black !important">
                                To attach the latest IPR and Pump curves into your summary, kindly press the "Attach Chart" button found near the chart in "IPR Curve" and "Pump Selection" sections.
                                <br /><br />
                                It is advised to reattach the charts before downloading the summary to get the latest chart version. 
                            </b-form-text>
                            <br />
                            <strong>Detaching Charts</strong>
                            <b-form-text style="color: black !important">
                                If you wish to remove a previously attached chart from the summary, you may do so by clicking the '[detach]' button beside the 'Attached Charts' list.
                            </b-form-text>
                        </b-alert>
                        <strong>Attached Charts</strong>
                        <ul>
                            <li v-if="!isIPRAttached && !isPumpAttached">No charts attached</li>
                            <li v-if="isIPRAttached">IPR Curve <sub @click="detach(1)"><a href="#">[detach]</a></sub></li>
                            <li v-if="isPumpAttached">Pump Curve <sub @click="detach(2)"><a href="#">[detach]</a></sub></li>
                        </ul>
                        <div class="mt-2" style="text-align: right">
                            <b-btn variant="success" @click="didTapDownloadSummary" :disabled="isDownloading">
                                {{ isDownloading ? "Preparing Summary..." : "Download Summary" }}&ensp;<font-awesome-icon icon="file-download" />
                            </b-btn>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "Overview",
    data() {
        return {
            isDownloading: false,
            isDeleting: false,
            general: {},
            password: "",
            
            isIPRAttached: false,
            isPumpAttached: false,
            isDetaching: false
        }
    },
    computed: {

        hasExactName() {
            return this.deleteName == this.general.name
        },

        isSummaryAvailable() {
            return this.$core.output != null && "midPerfo" in this.$core.output && 
                this.$core.pump != null && "graph" in this.$core.pump &&
                this.$core.pump.graph != null && "graph" in this.$core.pump.graph &&
                this.$core.equipment != null && "motor1" in this.$core.equipment
        }

    },
    methods: {

        didTapDownloadSummary() {
            
            this.isDownloading = true
            this.$axios.get("/generator/" + this.$core.id, { responseType: 'arraybuffer' }).then(res => {

                var data = new Blob([res.data])

                // Create new download name
                let fileName = `${this.general.name} Summary.pdf`

                if (typeof window.navigator.msSaveBlob === 'function') {
                    window.navigator.msSaveBlob(data, fileName)
                }
                else {
                    var blob = data
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = fileName

                    document.body.appendChild(link)

                    link.click()
                }

            })
            .catch(error => {
                this.$helper.toastError(this, error)
            })
            .finally(() => {
                this.isDownloading = false
            })

        },

        detach(type) {

            if(this.isDetaching) { return }

            let chart = type == 1 ? "IPR" : "Pump"
            let confirmed = confirm(`Detach ${chart} curve chart from the summary?`)

            if(confirmed) {

                let payload = {
                    id: this.$core.id,
                    type: type
                }

                this.isDetaching = true
                this.$axios.post('/calc/detachChart', payload).then(response => {

                    let res = response.data
                    if(res.message == "OK") {

                        if(type == 1) {
                            this.isIPRAttached = false
                            this.$core.attachment.ipr = false
                        }
                        else {
                            this.isPumpAttached = false
                            this.$core.attachment.pump = false
                        }

                        this.$helper.toastSuccess(this, `${chart} curve chart successfully detached!`)

                    }
                    else {
                        this.$helper.toastError(this, res.message)
                    }

                })
                .catch(error => {
                    this.$helper.toastError(this, error)
                })
                .finally(() => {
                    this.isDetaching = false
                })

            }

        },

        didTapDelete(modalEvent) {

            modalEvent.preventDefault()

            let payload = {
                id: this.$core.id,
                password: this.password
            }

            this.isDeleting = true
            this.$axios.post("/calc/delete", payload).then(response => {

                let res = response.data
                if(res.message == "OK") {
                    this.$router.push("/dashboard")
                }
                else {
                    this.$helper.toastError(this, res.message)
                }

            })
            .catch(error => {
                this.$helper.toastError(this, error)
            })
            .finally(() => {
                this.isDeleting = false
            })

        }

    },
    created: function() {

        this.general = this.$core.general
        this.isIPRAttached = this.$core.attachment.ipr
        this.isPumpAttached = this.$core.attachment.pump
        this.$router.app.$emit("changeTab", "overview")

    }
}
</script>

<style scoped>
    .strong {
        margin-bottom: 0;
    }
</style>